// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"928":"dc7b54b9b59cf011","13678":"57cb0da95d0342cc","28398":"b6323009d4472833","48846":"6438dbb375600f1b","60657":"1bd95b5a858d1212"}[chunkId] + ".css";
};